/* The Bannerman — "On TV Today" header badge (Option 1: broadcast red).
   Injects a single styled link to /pages/sports-on-tv-today into the site header.
   Self-contained, idempotent, theme-resilient: drops into the main nav if it can
   find it, otherwise pins a fixed badge top-right so it's always visible.
   To recolour later (e.g. to the gold "Option 3"), change --bg / colour below. */
(function () {
  if (window.__bnrOnTv) return;
  window.__bnrOnTv = true;

  var PAGE  = '/pages/sports-on-tv-today';
  var LABEL = 'On TV Today';

  var css = document.createElement('style');
  css.textContent = [
    '@keyframes bnrOnTvPulse{0%{box-shadow:0 0 0 0 rgba(255,255,255,.55)}70%{box-shadow:0 0 0 6px rgba(255,255,255,0)}100%{box-shadow:0 0 0 0 rgba(255,255,255,0)}}',
    '.bnr-ontv{background:#c0392b !important;color:#fff !important;font-family:"BC Sans",sans-serif !important;',
    'font-weight:800 !important;font-size:12px !important;text-transform:uppercase !important;letter-spacing:.6px !important;',
    'line-height:1 !important;text-align:center !important;height:32px !important;min-height:32px !important;max-height:32px !important;',
    'border:0 !important;width:186px !important;padding:0 12px !important;',
    'border-radius:6px !important;text-decoration:none !important;box-sizing:border-box !important;display:inline-flex !important;',
    'align-items:center !important;justify-content:center !important;gap:7px !important;white-space:nowrap !important;}',
    '.bnr-ontv:hover{background:#a93226 !important;color:#fff !important}',
    '.bnr-ontv .bnr-ontv-dot{width:8px !important;height:8px !important;border-radius:50%;background:#fff;margin:0 !important;flex:0 0 auto;animation:bnrOnTvPulse 1.8s infinite}',
    '.bnr-ontv-li{display:flex;align-items:center;list-style:none;margin:0 0 0 6px}',
    'ul.mobile-menu .bnr-ontv-li{margin:8px 0 8px 0}',
    '.bnr-ontv-fixed{position:fixed;top:12px;right:14px;z-index:99999}',
    // Brand: recolour the theme heading-highlight from green to the logo blue.
    '.heading-marker{background:#5d8db7 !important;color:#fff !important}',
    // Brand: "Love Thy Team" tagline to the right of the header logo.
    ".bnr-slogan-hdr{font-family:Georgia,'Times New Roman',serif;font-style:italic;font-weight:600;color:#5d8db7;font-size:1.05rem;letter-spacing:.4px;margin-left:7px;white-space:nowrap;align-self:center}",
    '@media(max-width:749px){.bnr-slogan-hdr{font-size:.8rem;margin-left:5px}}',
    // Repurpose the collection promo tile into a "Sign the Petition" card.
    '.bnr-petcard{padding:18px 14px;display:flex;flex-direction:column;align-items:center;justify-content:center;height:100%;text-align:center}',
    '.bnr-petcard-logo{height:58px;width:auto;margin:0 0 12px;display:block}',
    '.bnr-petcard-h{font-weight:800;font-size:1.12rem;line-height:1.25;color:#14181f;margin-bottom:5px}',
    '.bnr-petcard-sub{font-size:.9rem;color:#5b6572;margin-bottom:15px;line-height:1.35}',
    '.bnr-petcard-btn{background:#c9a24b;color:#15181d;font-weight:800;border:0;border-radius:8px;padding:11px 18px;font-size:.85rem;cursor:pointer;text-transform:uppercase;letter-spacing:.5px;font-family:inherit}',
    '.bnr-petcard-btn:hover{background:#d8b45f}'
  ].join('');
  document.head.appendChild(css);

  function badge() {
    var a = document.createElement('a');
    a.className = 'bnr-ontv';
    a.href = PAGE;
    a.setAttribute('aria-label', 'Sports on TV Today');
    a.innerHTML = '<span class="bnr-ontv-dot"></span>' + LABEL;
    return a;
  }

  function inject() {
    // Pinnacle theme: real nav lists are ul.thb-full-menu (desktop, holds
    // Contact) and ul.mobile-menu (inside the hamburger drawer). Drop the badge
    // into every one we find so it sits inline next to Contact on desktop AND
    // inside the mobile menu — never floating.
    var menus = document.querySelectorAll('ul.thb-full-menu, ul.mobile-menu');
    if (menus.length) {
      var placed = 0;
      menus.forEach(function (ul) {
        if (ul.querySelector('.bnr-ontv-li')) { placed++; return; }   // this menu already has it
        var li = document.createElement('li');
        li.className = 'bnr-ontv-li';
        li.appendChild(badge());
        ul.appendChild(li);
        placed++;
      });
      return placed > 0;
    }
    // fallback selectors for other themes
    var sels = ['.header__inline-menu > ul', 'nav[role="navigation"] ul',
                'header nav ul', '.list-menu--inline', '.site-nav__list', 'header ul'];
    for (var i = 0; i < sels.length; i++) {
      var ul = document.querySelector(sels[i]);
      if (ul && !ul.querySelector('.bnr-ontv-li')) {
        var li2 = document.createElement('li');
        li2.className = 'bnr-ontv-li';
        li2.appendChild(badge());
        ul.appendChild(li2);
        return true;
      }
    }
    if (document.querySelector('.bnr-ontv')) return true;   // already placed somewhere
    var f = badge();                       // last resort: always-visible fixed badge
    f.className = 'bnr-ontv bnr-ontv-fixed';
    document.body.appendChild(f);
    return true;
  }

  // "Love Thy Team" brand tagline placed just to the right of the header logo.
  function injectSlogan() {
    if (document.getElementById('bnr-slogan-hdr')) return;
    var link = document.querySelector('a.logolink') ||
               document.querySelector('.header--inner a[href="/"]');
    if (!link || !link.parentNode) return;
    var s = document.createElement('span');
    s.id = 'bnr-slogan-hdr';
    s.className = 'bnr-slogan-hdr';
    s.textContent = 'Love Thy Team';
    link.parentNode.insertBefore(s, link.nextSibling);   // sits just right of the logo
  }

  // Turn the theme's collection promo tile into a "Missing your team here?"
  // petition card (logo + Sign the Petition button that opens the petition popup
  // via petition.js's [data-open-petition] hook).
  function repurposePromo() {
    var cards = document.querySelectorAll('.product-card-promotion');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.getAttribute('data-bnr-pet')) continue;
      card.setAttribute('data-bnr-pet', '1');
      var content = card.querySelector('.product-card-promotion--content') || card;
      content.innerHTML =
        '<div class="bnr-petcard">' +
          '<img class="bnr-petcard-logo" src="https://thebannerman.ca/cdn/shop/files/Logo_Watermark.png?width=240" alt="The Bannerman">' +
          '<div class="bnr-petcard-h">Missing your team here?</div>' +
          '<div class="bnr-petcard-sub">Help us get licensed so we can release your team’s prints.</div>' +
          '<button type="button" class="bnr-petcard-btn" data-open-petition>✍ Sign the Petition</button>' +
        '</div>';
    }
  }

  function run() { inject(); injectSlogan(); repurposePromo(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  // some themes render the header/hero a beat late — retry harmlessly
  setTimeout(run, 1200);
  setTimeout(run, 3500);
})();
